import React                from 'react';
import numeral              from 'numeral';
import classnames           from 'classnames';
import { FontAwesomeIcon }  from '@fortawesome/react-fontawesome';

import BomReport            from './BomReport';
import BomQuantities        from './BomQuantities';
import BomQuoteTable        from './BomQuoteTable';
import ErrorLabel           from 'pu-react/components/base/ErrorLabel';

const Actions = (props) => {
  return(
    <div>
      <button type="button" className="btn btn-outline-gray btn-thin" 
        onClick={props.onClose} >
        CANCEL
      </button>
      &nbsp;
      <button type="button" className="btn btn-orange" 
        onClick={props.onSaveBom} >
        SAVE AND CONTINUE
        &nbsp;
        <i className="fas fa-caret-right"></i>
      </button>
    </div>
  )
}


const BomToolQuote = (props) => {
  var selected_quantity = props.selected_quantity;
  var quantities = props.quote.quantities;
  var offers = props.quote.offers;
  var report = props.quote.report;
  var vendors = props.quote.vendors;
  var totals = props.quote.totals;

  if (props.selected_quantity === null && props.quote!== undefined && props.quote.quantities !== undefined ){
    selected_quantity = props.quote.quantities[0];
  }

  return(
    <div className="bom-tool-quote">
      <BomReport 
        report={report}
        totals={totals} 
        vendors={vendors}
        quantities={quantities} 
        selected_quantity={selected_quantity} />
      <div className="d-flex justify-content-end">
        <BomQuantities 
         quantities={quantities} 
         selected_quantity={selected_quantity} 
         onChangeNumBoard={props.onChangeNumBoard} />
      </div>

      <ErrorLabel error={props.errors.change_part_action} />
      <ErrorLabel error={props.errors.purchase_status} />
      <BomQuoteTable 
        filter={props.filter} 
        offers={offers} 
        totals={totals} 
        quantities={quantities} 
        selected_quantity={selected_quantity} 
        onChangePartAction = {props.onChangePartAction}
        onChangeMountingType = {props.onChangeMountingType} 
        onFindSubstitutePart = {props.onFindSubstitutePart} />
      
      <div className="modal-footer">
        <Actions 
         onClose={props.onClose}
         onSaveBom={props.onSaveBom} />
      </div>
    </div>
  )
}

export default BomToolQuote;